import React, { Component } from 'react';
import throttle from 'lodash.throttle';

import AppControls from './AppControls';
import DomGrid from './DomGrid';
import { timePeriodFromCoords } from './utils';
import { getIndexes, indexGroupOrder } from './data/index';

import './App.css';

class App extends Component {
	constructor() {
		super();
		this.state = {
			// currentMatrixId: 'Dimensional_US_Market_Index',
			// currentMatrixId: 'Dimensional_Emerging_Markets_Adjusted_Market_Index',
			// currentMatrixId: 'Dimensional_Emerging_Markets_Index',
			currentMatrixId: 'Fama_French_US_Value_Research_Index',
			// currentMatrixId: 'Fama_French_Emerging_Markets_Growth_Index',
			availableIndexes: getIndexes('before'),
			showReturns: false,
			applyInflation: null, // false => before  || true => after
			selectedCell: null,
			highlightReturnsPeriod: [0, 0],
			zoom: 1,
			visibleHeight: null,
		};
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
		this.handleSelectMatrix = this.handleSelectMatrix.bind(this);
		this.handleSelectInflation = this.handleSelectInflation.bind(this);
		this.handleShowReturns = this.handleShowReturns.bind(this);
		this.handleSelectTimeframe = this.handleSelectTimeframe.bind(this);
		this.handleZoom = this.handleZoom.bind(this);
		this.handleOnCellClick = this.handleOnCellClick.bind(this);

		// use to get the height/width of the visible app container
		this.wrapperRef = React.createRef();
	}
	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', throttle(this.updateWindowDimensions, 500));
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}
	// listen for resize events and update state with new height of wrapper container
	updateWindowDimensions() {
		// TODO: this makes the matrix render twice, see if you can prevent that
		const node = this.wrapperRef.current;
		const { offsetWidth, offsetHeight } = node;
		this.setState((state, props) => ({ visibleHeight: offsetHeight}));
		console.log(`${offsetWidth}w x ${offsetHeight}h`);
	};	
	handleSelectMatrix(value, name) {
		this.setState((state, props) => ({ currentMatrixId: value, selectText: name }))
	}
	handleSelectInflation(value) {
		const inflation = value ? 'after' : 'before';
		const indexes = getIndexes(inflation);
		this.setState((state, props) => ({ applyInflation: value, availableIndexes: indexes }))
	}
	handleShowReturns(value) {
		this.setState((state, props) => ({ showReturns: value }))
	}
	handleSelectTimeframe(value) {
		this.setState((state, props) => ({ highlightReturnsPeriod: value }))
	}
	handleZoom(value) {
		this.setState((state, props) => ({ zoom: value}))
	}
	handleOnCellClick(coords) {
		console.log(coords);
		this.setState((state, props) => ({ selectedCell: coords }));
	}
	render() {
		const { 
			availableIndexes, 
			currentMatrixId, 
			selectedCell, 
			showReturns,
			highlightReturnsPeriod,
			visibleHeight,
			zoom
		} = this.state;
		
		const matrixFiles = Object.keys(availableIndexes).map((key) => {
			const { meta: { name, group }} = availableIndexes[key];
			return {
				value: key,
				label: name,
				group: group,
				order: indexGroupOrder[group]
			};
		});
		const currentMatrix = availableIndexes[currentMatrixId];
		const { meta: { timePeriod }} = currentMatrix;
		const selectedTimePeriod = timePeriodFromCoords(selectedCell, timePeriod);
		const growthPeriod = selectedTimePeriod ? selectedTimePeriod : timePeriod;

		return (
			<div className="App">
				<div className="wrapper" ref={this.wrapperRef}>
					<div id="main">
						<DomGrid
							currentMatrix={currentMatrix}
							currentMatrixId={currentMatrixId}
							showReturns={showReturns}
							selectedCell={selectedCell}
							timePeriod={timePeriod}
							highlightReturnsPeriod={highlightReturnsPeriod}
							visibleHeight={visibleHeight}
							zoom={zoom}
							onCellClick={this.handleOnCellClick}
						/>
					</div>
					<AppControls
						availableIndexes={availableIndexes}
						currentMatrix={currentMatrix}
						currentMatrixId={currentMatrixId}
						matrixFiles={matrixFiles}
						growthPeriod={growthPeriod}
						zoom={zoom}

						handleSelectMatrix={this.handleSelectMatrix}
						handleSelectInflation={this.handleSelectInflation}
						handleShowReturns={this.handleShowReturns}
						handleSelectTimeframe={this.handleSelectTimeframe}
						handleZoom={this.handleZoom}
						handleTimeframeSubmit={this.handleOnCellClick}
					/>
				</div>
			</div>
		);
	}
}

export default App;
